<template>
    <el-dialog
        :visible.sync="dialogVisible"
        @closed="handleClose"
        top="60px"
        title="离线下载中心"
        width="1100px"
        append-to-body>
        <div class="data-list-wrap relative">
            <div class="filter-bar">
                <el-form ref="form" :inline="true" size="mini" @submit.native.prevent="submitSearch">
                    <el-form-item label="文件名称：">
                        <el-input v-model="tempQuery.search" @keyup.enter.native="submitSearch" @clear="submitSearch" clearable placeholder="请输入文件名搜索" style="width: 200px;">
                            <el-button slot="append" icon="el-icon-search" @click="submitSearch"></el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="模块：">
                        <ESelect v-model="queryData.module_id" @change="submitSearch" filterable clearable style="width: 130px;">
                            <el-option label="全部" value="">全部</el-option>
                            <el-option v-for="item in moduleList" :label="item.module_name" :value="item.id" :key="item.id">
                                {{item.module_name}}
                            </el-option>
                        </ESelect>
                    </el-form-item>
                    <el-form-item label="状态：">
                        <ESelect v-model="queryData.status" @change="submitSearch" filterable clearable style="width: 100px;">
                            <el-option label="全部" value="">全部</el-option>
                            <el-option v-for="item in statusList" :label="item.name" :value="item.value" :key="item.value">
                                {{item.name}}
                            </el-option>
                        </ESelect>
                    </el-form-item>
                    <el-form-item label="操作时间：">
                        <el-date-picker
                            v-model="tempQuery.range_time"
                            @change="submitSearch"
                            style="width: 232px"
                            type="daterange"
                            align="center"
                            unlink-panels
                            :clearable="false"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd"
                            range-separator="~"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                </el-form>

            </div>
            <div class="data-list relative">
                <div class="count-time">
                    <el-progress v-if="refreshTimer" :width="20" :format="countText" :stroke-width="2" type="circle" :percentage="percentage"></el-progress>
                </div>
                <el-table
                    v-loading="dataLoading"
                    :data="dataList"
                    stripe
                    :max-height="360"
                    :header-cell-style="{background:'#e8eaec',color:'#333'}"
                    :default-sort = "{prop: 'log_time', order: 'descending'}"
                    style="width: 100%;min-height: 200px;">
                    <el-table-column
                        prop="module_name"
                        label="模块"
                        align="center"
                        width="150">
                    </el-table-column>
                    <el-table-column
                        prop="export_time"
                        label="导出时间"
                        align="center"
                        width="120">
                        <template slot-scope="scope">
                            <span>{{scope.row.export_time||'--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="filename"
                        label="文件名称"
                        align="center"
                        width="460">
                        <template slot-scope="scope">
                            <p class="tal">{{scope.row.filename||'--'}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="status"
                        label="导出状态"
                        align="center"
                        width="100">
                        <template slot-scope="scope">
                            <template v-if="scope.row.error">
                                <el-tooltip class="item" effect="dark" placement="top">
                                    <div slot="content" class="error-tips">
                                        {{scope.row.error}}
                                    </div>
                                    <span :class="'status-text-'+scope.row.status">{{scope.row.status_text||'--'}} <i class="el-icon-warning"></i></span>
                                </el-tooltip>
                            </template>
                            <span v-else :class="'status-text-'+scope.row.status">{{scope.row.status_text||'--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        property="action"
                        label="操作"
                        width="200px"
                        align="center">
                        <template slot-scope="scope">
                            <!--客户产品管理moduleId为3，不能重试-->
                            <el-link v-if="scope.row.status=='4'&&scope.row.module_id!='3'" type="primary" class="ml6 mr6" @click="retry(scope.row)">重试</el-link>
                            <el-link v-else type="primary" class="ml6 mr6" :class="scope.row.loading?'loading':''" :disabled="scope.row.status!='3'" 
                            v-matomo="{behaviorCategory: '系统功能', event: '点击',  name: '离线下载中心(下载)' }"
                            @click="checkDownload(scope.row)">下载</el-link>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page-bar tac mt20">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryData.pn"
                        :page-sizes="[10, 30,60]"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCnt">
                    </el-pagination>
                </div>
            </div>
            <div class="tips">
                <p class="text-color-error font12px">* 离线数据保存7天，超过7天的无法下载与重试</p>
            </div>
        </div>



    </el-dialog>
</template>

<script>
    import API from '@/api/download.js';
    import util from '@/libs/utils.js';
    import matomo from '@/utils/matomo.js'
    export default {
        name: "DownloadCenterModal",
        data() {
            return {
                dialogVisible: false,
                dataLoading:false,
                refreshLoading:false,
                queryData:{
                    range_time:[],
                    search:'',
                    module_id:'',
                    status:'',
                    pn: 1,
                    rn: 10,
                },
                tempQuery:{
                    module_id:'',
                    status:'',
                    search:'',
                    range_time:[],
                },
                moduleList:[],
                statusList:[
                    {
                        value:'1',
                        name:'正在导出',
                    },
                    {
                        value:'2',
                        name:'排队中',
                    },
                    {
                        value:'3',
                        name:'导出成功',
                    },
                    {
                        value:'4',
                        name:'导出失败',
                    },
                ],
                pickerOptions:{
                    disabledDate(time){
                        return time.getTime() > Date.now();
                    },
                },
                dataList:[],
                totalCnt:0,
                refreshTimer:null,
                refreshCountdown:0,
                refreshInterval:5,   //  刷新频率/秒
            }
        },
        computed:{
            percentage(){
                if(this.refreshCountdown<=0) return 100;
                if(this.refreshCountdown>=this.refreshInterval) return 0;
                return ((this.refreshInterval-this.refreshCountdown)/this.refreshInterval)*100;
            }
        },
        created(){
            this.latest7Days();
            this.getModuleList().then(()=>{
                if(this.moduleList.length>0){
                    // this.tempQuery.module = this.queryData.module = this.moduleList[0].id;
                    // this.tempQuery.module = this.queryData.module = '';
                }
            });
        },
        methods: {
            latest7Days () {
                let date = new Date();
                let year = date.getFullYear();
                let month = date.getMonth()+1;
                let day = date.getDate();
                let endDate = year+'-'+month+'-'+day;
                let lastMonthDay = new Date(date.getTime()-1000*60*60*24*7);
                let startDate = lastMonthDay.getFullYear()+'-'+(lastMonthDay.getMonth()+1)+'-'+lastMonthDay.getDate();
                this.tempQuery.range_time = [startDate,endDate];
            },
            handleClose() {
                this.resetForm();
                this.dialogVisible = false;
            },
            resetForm(){
                this.queryData.search = this.tempQuery.search = '';
                this.queryData.status = '';
                this.queryData.module_id = '';
                this.queryData.rn = 10;
                this.queryData.pn = 1;

                this.latest7Days();
                this.$refs['form'].resetFields();
            },
            showModal() {
                this.dialogVisible = true;

                /* 燕华要求，每次打开前重置时间 */
                this.latest7Days();

                this.$nextTick(()=>{
                    this.submitSearch();
                })
            },
            getModuleList(){
                return API.getDownloadModules().then(res=>{
                    this.moduleList = res.data||[];
                },err=>{
                    console.log('getDownloadModules',err);
                    this.moduleList = [];
                });
            },
            submitSearch(){
                this.queryData.pn=1;
                this.queryData.search = this.tempQuery.search;
                this.queryData.range_time = this.tempQuery.range_time;
                this.getDataList();
            },
            autoRefresh(){
                let idsArr = this.dataList.filter(item=>item.status!='3'&&item.status!='4').map(item=>item.id);
                if(idsArr.length<=0) {
                    clearTimeout(this.refreshTimer);
                    this.refreshTimer = null;
                    return this.refreshCountdown = 0;
                }
                this.refreshTimer = setTimeout(()=>{
                    console.log('this.refreshCountdown',this.refreshCountdown);
                    if(this.refreshCountdown>0){
                        this.refreshCountdown--;
                        this.autoRefresh();
                    }else{
                        this.refreshStatus();
                    }
                },1000)
            },
            checkDownload(row){
                let actionItem = this.dataList.find(item=>item.id==row.id);
                if(actionItem.loading) return;
                actionItem.loading = true;
                API.checkDownload({
                    id:row.id
                }).then(res=>{
                    let fileUrl = res.data;
                    if(fileUrl){
                        util.exportFile(fileUrl);
                    }

                    actionItem.loading = false;
                },err=>{
                    console.log('checkDownload err',err);
                    // this.$message.error(err.info||'请求失败');
                    actionItem.loading = false;
                    this.showErrors(err);
                });
            },
            showErrors(err){
                if(err.data&&err.data.length>0){
                    let htmlStr = '';
                    err.data.forEach(item=>{
                        htmlStr += `<p class="text-bold tal">${item.err_title}</p>`;
                        if(item.err_msg&&item.err_msg.length>0){
                            item.err_msg.forEach(err=>{
                                htmlStr += `<p class="tal">${err}</p>`;
                            })
                        }
                    });
                    this.$confirm(htmlStr, err.info||'以下已选条件无权限，下载失败', {
                        showCancelButton: false,
                        confirmButtonText: '我知道了',
                        type: 'error',
                        center: true,
                        dangerouslyUseHTMLString: true,
                        showClose: false,
                        distinguishCancelAndClose: true,
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                    });
                }else{
                    this.$message.error(err.info || '请求失败');
                }
            },
            retry(row){
                let actionItem = this.dataList.find(item=>item.id==row.id);
                if(actionItem.loading) return;
                actionItem.loading = true;
                API.retry({
                    id:row.id
                }).then(res=>{
                    this.getDataList();
                    this.$message.error(res.info || '请求成功');
                    actionItem.loading = false;
                },err=>{
                    console.log('retry err',err);
                    // this.$message.error(err.info||'请求失败');
                    actionItem.loading = false;
                    this.showErrors(err);
                });
            },
            handleSizeChange(val) {
                this.queryData.rn= val;
                this.getDataList();
            },
            handleCurrentChange(val) {
                this.queryData.pn= val;
                this.getDataList();
            },
            getDataList(){
                this.clearRefreshTimer();
                this.dataLoading = true;
                let data = {
                    search:this.queryData.search,
                    module_id:this.queryData.module_id,
                    status:this.queryData.status,
                    range_time:this.queryData.range_time.join('/'),
                    rn:this.queryData.rn,
                    pn:this.queryData.pn,
                };
                this.dataList = [];
                API.getDownloadList(data).then(res => {
                    let resData = res.data || {};
                    this.dataLoading = false;
                    this.dataList = (resData.list||[]).map(item=>{
                        item.loading = false;
                        return item;
                    });
                    this.totalCnt = resData.totalCnt;

                    this.refreshCountdown = this.refreshInterval;
                    this.autoRefresh();
                }, (err) => {
                    console.log('getUserList error', err);
                    this.$message.error(err.info||'请求有误');
                    this.dataList = [];
                    this.dataLoading = false;
                    this.totalCnt = 0;
                });

            },
            refreshStatus(){
                console.log('refreshStatus');

                let idsArr = this.dataList.filter(item=>item.status!='3'&&item.status!='4').map(item=>item.id);
                if(idsArr.length<=0) {
                    clearTimeout(this.refreshTimer);
                    this.refreshTimer = null;
                    return this.refreshCountdown = 0;
                }

                this.refreshLoading = true;
                API.getStatus({
                    ids:idsArr.join()
                }).then(res=>{
                    let resList = res.data||[];
                    resList.forEach(item=>{
                        let actionItem = this.dataList.find(data=>data.id == item.id);
                        if(actionItem){
                            actionItem.status_text = item.status_text;
                            actionItem.status = item.status;
                            actionItem.error = item.error;
                        }
                    });
                    this.refreshCountdown = this.refreshInterval;
                    this.autoRefresh();
                    this.refreshLoading = false;
                },err=>{
                    console.log('refreshStatus err',err);
                    this.refreshCountdown = this.refreshInterval;
                    this.autoRefresh();
                    this.refreshLoading = false;
                })
            },
            handleClose(){
                this.dialogVisible = false;
                matomo.trackEvent('系统功能', '点击', '离线下载中心(关闭)');
                this.clearRefreshTimer();
            },
            clearRefreshTimer(){
                clearTimeout(this.refreshTimer);
                this.refreshTimer = null;
            },
            countText(val){
                let num = this.refreshCountdown;
                if(num>=this.refreshInterval){
                    return '';
                }else if(num<=0){
                    return '1'
                }else{
                    return ''+(num+1);
                }
            },
        },
        beforeDestroy() {
            this.clearRefreshTimer();
        }
    }
</script>

<style lang="scss" scoped >
    .action-btn{
        width: 120px;
    }

    .loading{
        cursor: progress;
    }

    ::v-deep .el-form-item__label{
        padding: 0 6px 0 0;
    }

    ::v-deep .el-dialog__body{
        padding: 20px 20px 10px;
    }

    .status-text-0{
        /*color: #333;*/
    }
    .status-text-1{
        color: #2b85e4;
    }
    .status-text-2{
        /*color: #333;*/
    }
    .status-text-3{
        color: #19be6b;
    }
    .status-text-4{
        color: #ed4014;
    }

    .count-time{
        position: absolute;
        z-index: 11;
        right: 200px;
        top: 10px;

        ::v-deep .el-progress__text{
            font-size: 12px!important;
        }
    }

    .error-tips{
        white-space:pre-wrap;
        line-height: 20px;
    }
</style>
